module.exports = __webpack_public_path__ + "img/40.41899012.png";